import { render, staticRenderFns } from "./serviceSettings.vue?vue&type=template&id=b642fbb4&scoped=true&"
import script from "./serviceSettings.vue?vue&type=script&lang=js&"
export * from "./serviceSettings.vue?vue&type=script&lang=js&"
import style0 from "./serviceSettings.vue?vue&type=style&index=0&id=b642fbb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b642fbb4",
  null
  
)

export default component.exports